import { useEffect, useState } from 'react';
import styles from './Terminal.module.css';

export const MatrixRain = () => {
  const [chars, setChars] = useState<string[][]>([]);

  useEffect(() => {
    const generateChars = () => {
      const newChars = Array(12)
        .fill(null)
        .map(() =>
          Array(12)
            .fill(null)
            .map(() => String.fromCharCode(33 + Math.random() * 93))
        );
      setChars(newChars);
    };

    generateChars();
    const interval = setInterval(generateChars, 100);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles['matrix-container']}>
      <div className="grid grid-cols-12 gap-1 text-xs opacity-20">
        {chars.map((column, i) => (
          <div key={i} className={styles['matrix-rain']}>
            {column.map((char, j) => (
              <div key={j} className="my-0.5">
                {char}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
